<template>
    <div class="todo-page">
        <Pane title="待办事项"/>

        <div class="card-block">
            <!-- 搜索栏区域 -->
            <div class="todo-top-filter">
                <div class="filter-item">
                    <span class="filter-label">标题</span>
                    <a-input
                        v-model="filterTitle"
                        placeholder="搜索待办标题..."
                        class="filter-title-input"
                        allow-clear
                        @pressEnter="handleSearch"
                    ></a-input>
                </div>
                <div class="filter-item">
                    <span class="filter-label">状态</span>
                    <a-select
                        v-model="filterStatusList"
                        mode="multiple"
                        placeholder="全部待办"
                        class="filter-status-select"
                        allow-clear
                    >
                        <a-select-option v-for="item in todoTabs" :key="item.key" :value="item.key">
                            {{ item.label }}
                        </a-select-option>
                    </a-select>
                </div>
                <div class="filter-item">
                    <span class="filter-label">标签</span>
                    <a-select
                        v-model="activeTags"
                        mode="multiple"
                        placeholder="选择标签"
                        class="filter-tag-select"
                        allow-clear
                        @change="handleSearch"
                    >
                        <a-select-option v-for="tab in tagOptions" :key="tab.value" :value="tab.value">
                            {{ tab.name }}
                        </a-select-option>
                    </a-select>
                </div>
                <a-space>
                    <a-button type="primary" @click="handleSearch">查询</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-space>
            </div>

            <!-- 待办列表 -->
            <a-list v-if="todoData.length" :data-source="todoData" class="todo-list-wrap">
                <template slot="renderItem" slot-scope="item">
                    <a-list-item class="todo-list-item">
                        <!-- 左侧复选框 -->
                        <a-checkbox class="todo-checkbox"></a-checkbox>
                        <!-- 图标区块 -->
                        <div class="todo-icon-block" :style="{background:item.iconBg}">
                            <a-icon :type="item.iconType" :style="{color:item.iconColor}" />
                        </div>
                        <!-- 中间文字信息 -->
                        <div class="todo-info">
                            <div class="todo-title" @click="handleTodoTitle(item)">{{ item.title }}</div>
                            <div class="todo-desc">
                                <span>{{ item.roleLabel }}</span>
                                {{ item.handlerName }} &nbsp; {{ item.category }}</div>
                        </div>
                        <!-- 右侧优先级、截止时间、按钮 -->
                        <div class="todo-right-area">
                            <div class="todo-right-info">
                                <!--<div class="todo-level-text" :class="item.levelClass">{{ item.priority }}</div>-->
                                <div class="todo-deadline-text" :class="item.deadlineClass">{{ item.deadlineDate ? formatDeadlineDate(item.deadlineDate) : (item.createAt ? formatCreateDate(item.createAt) : '') }}</div>
                            </div>
                            <a-button
                                v-if="item.source === 'approval_center'"
                                type="primary"
                                :disabled="item.tag === 'track' || !['approving', 'processing', 'pending', 'not_started'].includes(item.status)"
                                @click="handleTodo(item)"
                            >{{ ['approving', 'processing', 'pending', 'not_started'].includes(item.status) ? '去处理' : item.statusText }}</a-button>
                            <a-button
                                v-else
                                type="primary"
                                :disabled="item.tag === 'track' || !(item.source === 'meeting' && (item.status === 'not_started' || item.status === 'pending'))"
                                @click="handleTodo(item)"
                            >{{ item.statusText }}</a-button>
                        </div>
                    </a-list-item>
                </template>
            </a-list>
            <a-empty v-else description="暂无待办事项" class="todo-list-wrap" />
            <div class="todo-pagination" v-if="totalSize > 0">
                <a-pagination
                    :current="pageNum"
                    :page-size="pageSize"
                    :total="totalSize"
                    :show-total="total => `共 ${total} 条`"
                    show-size-changer
                    :page-size-options="['10', '20', '50', '100']"
                    @change="handlePaginationChange"
                    @showSizeChange="handlePaginationChange"
                />
            </div>
        </div>
        <Invitation :visible.sync="invitationVisible" :todo="currentTodo" @refresh="handleSearch" />
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { todoList, todoComplete } from "@/api/approval/todo";
import Invitation from "@/views/desk/components-desk/Invitation.vue";
export default {
    name: 'TodoCenter',
    components: {
        Invitation
    },
    data() {
        return {
            invitationVisible: false,
            currentTodo: null,
            filterStatusList: [],
            //filterStatusList: ['approving', 'not_started', 'processing', 'pending'],
            filterPriority: undefined,
            filterTitle: undefined,
            activeTags: ['approval', 'execute', 'confirm'],
            todoData: [],
            pageNum: 1,
            pageSize: 20,
            totalSize: 0,
            totalPages: 0
        }
    },
    computed: {
        ...mapGetters("setting", ["findDataDict", "findSingleDictName"]),
        todoTabs() {
            return [...(this.findDataDict("todoStatus") || []).map(item => ({ key: item.value, label: item.name }))];
        },
        tagOptions() {
            return [...(this.findDataDict("todoTag") || [])];
        },
        priorityOptions() {
            return this.findDataDict("todoPriority") || [];
        }
    },
    mounted() {
        if (this.$route.query.tags) {
            this.activeTags = this.$route.query.tags.split(',');
        }
        if (this.$route.query.statusList) {
            this.filterStatusList = this.$route.query.statusList.split(',');
        }
        if (this.$route.query.tags && this.$route.query.tags.includes('track') && !this.$route.query.statusList) {
            this.filterStatusList = ['approving', 'processing', 'pending', 'not_started'];
        }
        this.getList();
    },
    methods: {
        ...mapMutations("tabs", ["setTabList"]),
        handleGoTodo() {
            const path = '/todo';
            const tabList = [...this.$store.state.tabs.tabList];
            if (!tabList.some(t => t.path === path)) {
                tabList.push({ name: '待办事项', path, fullPath: path });
                this.setTabList(tabList);
            }
        },
        // 重置筛选条件
        handleReset() {
            this.filterTitle = undefined;
            this.filterStatusList = [];
            this.activeTags = ['approval', 'execute', 'confirm'];
            this.getList();
        },
        handleSearch() {
            this.getList();
        },
        handleTodo(item) {
            if (item.title && item.title.startsWith('会后处理') && item.bizId) {
                const path = `/oa/meeting/handling?id=${item.bizId}`;
                const basePath = `/oa/meeting/handling`;
                const tabList = [...this.$store.state.tabs.tabList];
                if (!tabList.some(t => t.path === basePath)) {
                    tabList.push({ name: '会后处理', path: basePath, fullPath: path });
                    this.setTabList(tabList);
                }
                this.$router.push(path).catch(() => {});
                return;
            }
            if (item.source === 'meeting' && item.title && item.title.indexOf('归档会议') > -1 && item.bizId) {
                const path = `/oa/meeting/detail?id=${item.bizId}`;
                const basePath = `/oa/meeting/detail`;
                const tabList = [...this.$store.state.tabs.tabList];
                if (!tabList.some(t => t.path === basePath)) {
                    tabList.push({ name: '会议详情', path: basePath, fullPath: path });
                    this.setTabList(tabList);
                }
                this.$router.push(path).catch(() => {});
                todoComplete({
                    bizId: item.bizId,
                    bizSubId: item.bizSubId,
                    ignoreHandler: true,
                    status: 'completed'
                }).then(() => {
                    // this.$message.success('待办已处理');
                    this.getList(this.pageNum, this.pageSize);
                }).catch(() => {});
                return;
            }
            if (item.source === 'approval_center' && item.bizId) {
                const params = new URLSearchParams(item.bizId);
                const taskId = params.get('taskId');
                const instanceId = params.get('instanceId');
                if (taskId && instanceId) {
                    this.$router.push({
                        path: '/approval/task/detail',
                        query: {
                            taskId,
                            instanceId,
                            activeKey: item.status === 'completed' ? 'COMPLETED' : 'RUNNING'
                        }
                    });
                    return;
                }
            }
            if (item.source === 'meeting' && item.status === 'completed' && item.bizId) {
                this.$router.push({
                    path: '/oa/meeting/detail',
                    query: { id: item.bizId }
                });
                return;
            }
            this.currentTodo = item;
            this.invitationVisible = true;
        },
        handleTodoTitle(item) {
            console.log("item::::",item)
            if (item.title && item.title.indexOf('请确认产值进度月报') > -1 && item.bizId) {
                const path = `/finance/progress-report/detail?reportId=${item.bizId}`;
                const basePath = `/finance/progress-report/detail`;
                const tabList = [...this.$store.state.tabs.tabList];
                if (!tabList.some(t => t.path === basePath)) {
                    tabList.push({ name: '产值进度月报详情', path: basePath, fullPath: path });
                    this.setTabList(tabList);
                }
                this.$router.push(path).catch(() => {});
                return;
            }
            if (item.tag === 'track' && item.source === 'approval_center' && item.bizId && item.bizSubId) {
                this.$router.push({
                    path: '/approval/task/detail',
                    query: {
                        taskId: item.bizSubId,
                        instanceId: item.bizId
                    }
                });
                return;
            }
            if (item.source === 'approval_center' && item.bizId) {
                const params = new URLSearchParams(item.bizId);
                const taskId = params.get('taskId');
                const instanceId = params.get('instanceId');
                if (taskId && instanceId) {
                    this.$router.push({
                        path: '/approval/task/detail',
                        query: {
                            taskId,
                            instanceId,
                            activeKey: item.status === 'completed' ? 'COMPLETED' : 'RUNNING'
                        }
                    });
                    return;
                }
            }

            if (item.source === 'supervision' && item.bizSubId) {
                this.$router.push({
                    path: '/oa/supervise/detail',
                    query: { id: item.bizSubId }
                });
                return;
            }

            if (item.source === 'meeting' && item.bizId) {
                const path = `/oa/meeting/detail?id=${item.bizId}`;
                const basePath = `/oa/meeting/detail`;
                const tabList = [...this.$store.state.tabs.tabList];
                if (!tabList.some(t => t.path === basePath)) {
                    tabList.push({ name: '会议详情', path: basePath, fullPath: path });
                    this.setTabList(tabList);
                }
                this.$router.push(path).catch(() => {});
                return;
            }
            this.currentTodo = item;
            this.invitationVisible = true;
        },
        getList(pageNum, pageSize) {
            const params = {
                pageNum: pageNum || 1,
                pageSize: pageSize || this.pageSize,
                title: this.filterTitle || undefined,
                tags: this.activeTags.length > 0 ? this.activeTags : undefined,
                statusList: this.filterStatusList.length > 0 ? this.filterStatusList.filter(s => s !== 'all') : undefined
            };
            todoList(params).then(res => {
                if (!res || !Array.isArray(res.list)) {
                    this.todoData = [];
                    this.totalSize = 0;
                    this.totalPages = 0;
                    return;
                }
                this.totalSize = res.totalSize || 0;
                this.totalPages = res.totalPages || 0;
                this.pageNum = res.pageNum || params.pageNum;
                this.pageSize = res.pageSize || params.pageSize;
                const iconTypeList = ['edit', 'calendar', 'bar-chart', 'file-text', 'tag', 'clock-circle'];
                const iconBgList = ['#fcf0ef', '#eef6ff', '#fff7e6', '#f0fff4', '#f9f0ff', '#e6f7ff'];
                const iconColorList = ['#e5484d', '#2563eb', '#fa8c16', '#16a34a', '#9254de', '#1890ff'];
                let list = res.list;
                if (this.filterPriority) {
                    list = list.filter(item => item.priority === this.filterPriority);
                }
                this.todoData = list.map((item, index) => {
                    const priorityName = this.findSingleDictName('todoPriority', item.priority);
                    const levelClass = this.getLevelClass(priorityName);
                    const idx = index % iconTypeList.length;
                    return {
                        ...item,
                        title: item.title || item.content || '',
                        user: item.createBy || item.handlerName || '',
                        category: this.findSingleDictName('todoTag', item.tag) || item.tag || '',
                        roleLabel: item.source === 'approval_center' ? '审核人：' : item.source === 'supervision' ? '执行人：' : '参会人：',
                        statusText: this.findSingleDictName('todoStatus', item.status) || item.status || '',
                        deadlineDate: item.deadlineDate ? item.deadlineDate.slice(0, 10) : '',
                        deadline: this.formatDeadline(item.deadlineDate),
                        priority: priorityName || item.priority || '',
                        levelName: priorityName || '',
                        levelClass,
                        deadlineClass: levelClass,
                        iconType: iconTypeList[idx],
                        iconBg: iconBgList[idx],
                        iconColor: iconColorList[idx]
                    };
                });
            });
        },
        handlePaginationChange(pageNum, pageSize) {
            this.pageNum = pageNum;
            this.pageSize = pageSize;
            this.getList(pageNum, pageSize);
        },
        getLevelClass(priorityName) {
            if (priorityName.indexOf('紧急') > -1) return 'text-red';
            if (priorityName.indexOf('较高') > -1 || priorityName.indexOf('高') > -1) return 'text-orange';
            return 'text-blue';
        },
        formatDeadline(dateStr) {
            return this.formatDeadlineDate(dateStr);
        },
        formatDeadlineDate(dateStr) {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return dateStr;
            return `${date.getMonth() + 1}月${date.getDate()}日截止`;
        },
        formatCreateDate(dateStr) {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return dateStr;
            return `${date.getMonth() + 1}月${date.getDate()}日创建`;
        }
    }
}
</script>

<style scoped>
.card-block {
    background: #fff;
    border-radius: 12px;
    padding: 0px 24px 30px 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
}

/* ========== 待办中心样式 ========== */
.todo-top-filter {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    padding: 16px 0;
    margin-bottom: 6px;
    border-bottom: 1px solid #f0f0f0;
}
.filter-item {
    display: flex;
    align-items: center;
    gap: 8px;
}
.filter-label {
    font-size: 13px;
    color: #666;
    white-space: nowrap;
}
.filter-title-input {
    width: 220px;
}
.filter-status-select {
    min-width: 200px;
}
.filter-tag-select {
    min-width: 260px;
}
.todo-list-wrap {
    height: 60vh;
    overflow-y: auto;
}
::v-deep .todo-list-wrap .ant-list-item {
    padding: 8px 0 !important;
}
.todo-list-item {
    display: flex;
    align-items: center;
    gap: 12px;
}
.todo-icon-block {
    width: 42px;
    height: 42px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.todo-info {
    flex: 1;
}
.todo-title {
    font-size: 13px;
    font-weight: 550;
    color: #5c5c5c;
    cursor: pointer;
}
.todo-title:hover {
    color: #2563eb;
}
.todo-desc {
    font-size: 12px;
    color: #666;
    margin-top: 3px;
}
.todo-right-area {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
}
.todo-right-info {
    text-align: right;
}
.todo-level-text {
    font-size: 12px;
    font-weight: 500;
}
.todo-deadline-text {
    font-size: 13px;
    font-weight: 500;
}
.text-red {
    color: #e5484d;
}
.text-orange {
    color: #fa8c16;
}
.text-blue {
    color: #2563eb;
}
.text-gray {
    color: #666;
}
.todo-pagination {
    display: flex;
    justify-content: flex-end;
    padding-top: 16px;
}
</style>
